<!-- eslint-disable -->
<template>
  <div class="G_modal">
    <div class="c2m7_modal_header">
      <modal-header
        @event-close-child-modals="eventCloseChildModals"
        @event-close-modal="selfClose"
        :title="modalTitle"
      ></modal-header>
      <h3>
        <c22-full-path-label
          v-if="isInitiailized"
          :showOrgParents="true"
          :orgUid="actualOrgUid"
          :systemUid="actualSystemUid"
          :objectUid="actualObjectUid"
          :objectAttributeUid="actualObjectAttributeUid"
        ></c22-full-path-label>
      </h3>
    </div>

    <div class="c2m7_notification_groups_box">
      <button 
        @click.stop="selectGroupType('personal')"
        class="c2m7-personal-rules-button"
        :class="{active: DV_selectedGroup === 'personal'}"
        :disabled="DV_loadingNGPRuleJoins"
      >
        Personal Default Rules
      </button>
      <button 
        v-for="group in DV_notificationGroupsData"
        @click.stop="selectGroupType(group.uid)"
        :class="{active: DV_selectedGroup === group.uid}"
        :disabled="DV_loadingNGPRuleJoins"
      >
        {{group.name}}
      </button>
    </div>
    <div class="c2m7_grid_container">
      <div class="c2m7_assigned_table_area">
        <h2 class="c2m7_assigned_rules_label"></h2>
        <hr>
        <div v-if="DV_loadingNGPRuleJoins">
          Loading...
        </div>
        <div v-else-if="C_filteredAssignedRulesList.length === 0">
          No rules are available to show
        </div>
        <c2m7c1-rule-entry
          v-else
          v-for="rule in C_filteredAssignedRulesList"
          :key="rule.uid"
          :orgUid="orgUid"
          :ruleUid="rule.uid"
          :ruleName="rule.name"
          :ruleDescription="rule.description"
          :doghouseChecked="rule.type_doghouse"
          :instantChecked="rule.type_instant"
          :daillyChecked="rule.type_daily"
          :instantRetriggerTime="rule.instant_retrigger_time"
          :selectedRuleUid="activeRuleUid"
          :showRemoveButton="true"
          :showNotificationTypes="true"
          :assigningRuleId="assigningRuleId"
          :unassigningRuleId="unassigningRuleId"
          :class="{ 'c2m7_unassigning_rule': unassigningRuleId !== null && rule.uid === unassigningRuleId }"
          :selectedGroupType="DV_selectedGroup"
          @event-assign-rule="eventAssignRule"
          @event-unassign-rule="eventUnassignRule"
          @event-change-rule-notification-type="eventChangeRuleNotificationType"
          @event-set-children-visible="eventSetChildrenVisible"
        ></c2m7c1-rule-entry>
      </div>
      <div class="c2m7_unassigned_table_area">
        <h2 class="c2m7_unassigned_rules_label"></h2>
        <hr>
        <div v-if="DV_loadingNGPRuleJoins">Loading...</div>
        
        <div v-else-if="C_filteredUnAssignedRulesList.length === 0">
          No rules are available to show
        </div>
        <c2m7c1-rule-entry
          v-else
          v-for="rule in C_filteredUnAssignedRulesList"
          :key="rule.uid"
          :orgUid="orgUid"
          :ruleUid="rule.uid"
          :ruleName="rule.name"
          :ruleDescription="rule.description"
          :selectedRuleUid="activeRuleUid"
          :showAssignButton="true"
          :assigningRuleId="assigningRuleId"
          :unassigningRuleId="unassigningRuleId"
          :selectedGroupType="DV_selectedGroup"
          @event-assign-rule="eventAssignRule"
        ></c2m7c1-rule-entry>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import ModalHeader from "../p2ModalHeader";
import c22FullPathLabel from "../../Labels/c22FullPathLabel";
import { bi10ModalTemplate } from "../../../watchdog_includes/base_i10_UI_mixins";
import bi6_misc from "../../../watchdog_includes/base_i6_misc_functions";
import assignNotificationRule from "../../../watchdog_includes/json_tasks/p2s7/p2s7t7";
import unassignNotificationRule from "../../../watchdog_includes/json_tasks/p2s7/p2s7t8";
import linkNotificationGroupRuleToObject from "../../../watchdog_includes/json_tasks/p2s9/p2s9t7";
import unlinkNotificationGroupRuleFromObject from "../../../watchdog_includes/json_tasks/p2s9/p2s9t8";
import c2m7c1RuleEntry from "./c2m7/c2m7c1RuleEntry";
import AWN from "awesome-notifications";

export default {
  name: "c2m7ManageNotifications",
  components: {
    ModalHeader,
    c22FullPathLabel,
    c2m7c1RuleEntry,
  },
  data() {
    return {
      modalTitle: "Manage Notifications",
      defaultModal: "default",
      activeRuleUid: null,
      assignedRulesList: [],
      assignedRulesListExistIndexes: {},
      ruleJoins: {},
      notificationRules: {},
      unassignedRulesList: [],
      actualOrgUid: null,
      actualSystemUid: null,
      actualObjectUid: null,
      actualObjectAttributeUid: null,
      assigningRuleId: null,
      unassigningRuleId: null,
      DV_orgNotificationGroupJoins: {},
      DV_notificationGroupMetaData: {},
      DV_notificationGroupsData: [],
      DV_selectedGroup: 'personal',
      DV_loadingNGPRuleJoins: false,
      DV_loadingRulesInformation: false,
      DV_notificatuinGroupRuleJoinsRef: {},
      DV_notificationGroupRuleJoins: {},
      DV_ngpRulesInformationData: {},
      DV_notificationGroupsInformation: {},
      DV_ngpRulesAssignmentDataRef: {},
      DV_ngpUidsWithActiveListeners: []
    };
  },
  props: ["orgUid", "systemUid", "objectUid", "objectAttributeUid"],
  mixins: [bi10ModalTemplate],
  computed: {
    C_filteredAssignedRulesList() {
      if (this.DV_selectedGroup === 'personal') {
        return this.assignedRulesList;
      }

      if (!this.DV_selectedGroup) { return [];}

      if (this.DV_loadingRulesInformation || this.DV_loadingNGPRuleJoins) {return [];}

      let available_rules = this.DV_notificationGroupRuleJoins[this.DV_selectedGroup];
      let assigned_rules = [];

      for (let key in available_rules) {

        if (this.DV_selectedGroup in this.DV_ngpRulesAssignmentDataRef === true) {
          if (key in this.DV_ngpRulesAssignmentDataRef[this.DV_selectedGroup] === true) {
            let assignments = this.DV_ngpRulesAssignmentDataRef[this.DV_selectedGroup][key];

            for (let assignment_key in assignments) {
              let assignment_data = assignments[assignment_key];

              if (assignment_data.sys_uid === this.actualSystemUid &&
                  assignment_data.obj_atr_uid === this.actualObjectAttributeUid) 
              { 
                let entry = Object.assign({}, assignment_data);

                if (key in this.DV_ngpRulesInformationData === true) {
                  entry["name"] = this.DV_ngpRulesInformationData[key]["name"];
                  entry["description"] = this.DV_ngpRulesInformationData[key]["description"];
                } else {
                  entry["name"] = "Deleted Rule."
                }

                assigned_rules.push(entry)
              }
            }
          }
        }
      }

      return assigned_rules;
    },
    C_filteredUnAssignedRulesList() {
      if (this.DV_selectedGroup === 'personal') {
        return this.unassignedRulesList;
      }

      if (!this.DV_selectedGroup) { return [];}

      if (this.DV_loadingRulesInformation || this.DV_loadingNGPRuleJoins) {return [];}
      
      let available_rules = this.DV_notificationGroupRuleJoins[this.DV_selectedGroup];
      let un_assigned_rules = [];

      for (let key in available_rules) {
        var is_assigned = false;
        if (this.DV_selectedGroup in this.DV_ngpRulesAssignmentDataRef === true) {
          if (key in this.DV_ngpRulesAssignmentDataRef[this.DV_selectedGroup] === true) {
            let assignments = this.DV_ngpRulesAssignmentDataRef[this.DV_selectedGroup][key];

            for (let assignment_key in assignments) {
              let assignment_data = assignments[assignment_key];

              if (assignment_data.sys_uid === this.actualSystemUid &&
                  assignment_data.obj_atr_uid === this.actualObjectAttributeUid) 
              { 
                is_assigned = true;
                break;
              }
            }
          }
        }

        if (is_assigned === true) {continue;}

        let entry = {name: key, uid: key, description: ""}

        if (key in this.DV_ngpRulesInformationData === true) {
          entry["name"] = this.DV_ngpRulesInformationData[key]["name"];
          entry["description"] = this.DV_ngpRulesInformationData[key]["description"];
        } else {
          entry["name"] = "Deleted Rule"
        }

        un_assigned_rules.push(entry)
      }

      return un_assigned_rules;
    }
  },
  methods: {
    startOrgGroupJoinListener() {
      //we have to make sure the firebase DB is actually connected since the page will sometimes request it before firebase can connect
      if (window.vue_instance.$data.watchdog.watchdogDbConnected == true && this.orgUid !== null &&
          window.vue_instance.$data.watchdog.orgCountAndLoading['is_loading'] === false
      ) {
        // To get NGPs available from all parent orgs
        const parent_org_uids = window.G_watchdog_data.IV_org_parents_lookup[this.orgUid];

        // To get NGPs direcly associate with this org
        const orgs_in_path = [...parent_org_uids, this.orgUid];

        for (let org_uid of orgs_in_path) {
          window.G_watchdog_data.bi7InitOrgNotificationGroupJoinsListener(org_uid);
        }
      } else {
        setTimeout(this.startOrgGroupJoinListener, 2000);
      }
    },
    eventAssignRule(args) {
      if (this.DV_selectedGroup !== 'personal') {
        this.assignNGPRule(args);
        return;
      }
      this.assigningRuleId = args[0];
      var rule_uid = args[0];
      var notitcation_types_string = args[1];
      var email_retrigger_time = parseInt(args[2]);
      if (Object.is(email_retrigger_time, NaN)) {
        console.error("c2m7ManageNotifications:eventAssignRule trigger_time is not a number.");
        this.assigningRuleId = null;
        return;
      }
      this.activeRuleUid = rule_uid;
      var resp = assignNotificationRule(
        window.G_firebase_auth.IV_email_address,
        window.G_firebase_auth.IV_id_token,
        window.G_watchdog_data.IV_user_info.uid,
        rule_uid,
        this.objectAttributeUid,
        notitcation_types_string,
        email_retrigger_time
      );
      resp.then(function() {
        this.assigningRuleId = null;
      }.bind(this));
    },
    assignNGPRule(args) {
      this.assigningRuleId = args[0];
      var rule_uid = args[0];
      var notitcation_types_string = args[1];
      var email_retrigger_time = parseInt(args[2]);

      if (Object.is(email_retrigger_time, NaN)) {
        console.error("c2m7ManageNotifications:assignNGPRule trigger_time is not a number.");
        this.assigningRuleId = null;
        return;
      }

      var resp = linkNotificationGroupRuleToObject(
        window.G_firebase_auth.IV_email_address,
        window.G_firebase_auth.IV_id_token,
        window.G_watchdog_data.IV_user_info.uid,
        this.DV_selectedGroup,
        rule_uid,
        this.objectUid,
        this.objectAttributeUid,
        notitcation_types_string,
        email_retrigger_time
      );
      resp.then(function() {
        this.assigningRuleId = null;
      }.bind(this));
    },
    eventUnassignRule(rule_uid) {
      if (this.DV_selectedGroup !== 'personal') {
        this.unAssignNGPRule(rule_uid);
        return;
      }
      this.unassigningRuleId = rule_uid;
      this.activeRuleUid = rule_uid;
      var resp = unassignNotificationRule(
        window.G_firebase_auth.IV_email_address,
        window.G_firebase_auth.IV_id_token,
        window.G_watchdog_data.IV_user_info.uid,
        rule_uid,
        this.objectAttributeUid
      );
      resp.then(function() {
        this.unassigningRuleId = null;
      }.bind(this))
    },
    unAssignNGPRule(rule_uid) {
      this.unassigningRuleId = rule_uid;
      this.activeRuleUid = rule_uid;
      var resp = unlinkNotificationGroupRuleFromObject(
        window.G_firebase_auth.IV_email_address,
        window.G_firebase_auth.IV_id_token,
        window.G_watchdog_data.IV_user_info.uid,
        this.DV_selectedGroup,
        rule_uid,
        this.actualObjectUid,
        this.objectAttributeUid
      );
      resp.then(function() {
        this.unassigningRuleId = null;
      }.bind(this))
    },
    waitWatchdogReadyCallback() {
      this.notificationRules = window.G_watchdog_data.IV_notification_rules;
      this.startOrgGroupJoinListener();
      this.DV_orgNotificationGroupJoins = window.G_watchdog_data.IV_org_ngp_joins;
      this.DV_notificationGroupMetaData = window.G_watchdog_data.IV_ngp_meta_data;
      this.setUidValues();
    },

    setUidValues() {
      var check_vars = [this.objectAttributeUid];
      for (var index in check_vars) {
        if (
          check_vars[index] === null ||
          check_vars[index] === undefined ||
          typeof check_vars[index] !== "string" ||
          check_vars[index].length < 3
        ) {
          setTimeout(this.setUidValues, 300);
          return;
        }
      }

      //ensure the firebase data is loaded before rendering
      if (this.objectAttributeUid in window.G_watchdog_data.IV_object_attribute_rule_joins === false) {
          setTimeout(this.setUidValues, 300);
          return;
      }
      
      this.actualOrgUid = this.orgUid;
      this.actualSystemUid = this.systemUid;
      this.actualObjectUid = this.objectUid;
      this.actualObjectAttributeUid = this.objectAttributeUid;
      this.ruleJoins = window.G_watchdog_data.IV_object_attribute_rule_joins[this.actualObjectAttributeUid];
    },
    updateRulesList() {
      var index_location = 0;
      //// make the list of rules assigned to this object attribute
      var assigned_rules_list = [];
      var assigned_rules_exists_flags = {}
      for (var key in this.ruleJoins) {
          assigned_rules_exists_flags[this.ruleJoins[key]["rule_uid"]] = index_location;
          var join_object = {};
          var rule_uid = this.ruleJoins[key]["rule_uid"];
          join_object.name = this.notificationRules[rule_uid].name;
          join_object.description = this.notificationRules[rule_uid].description;
          join_object.uid = rule_uid;
          join_object.type_doghouse = this.ruleJoins[key]["type_doghouse"];
          join_object.type_instant = this.ruleJoins[key]["type_instant"];
          join_object.type_daily = this.ruleJoins[key]["type_daily"];
          join_object.instant_retrigger_time = this.ruleJoins[key]["retrigger_time"];
          assigned_rules_list.push(join_object);
      }
      assigned_rules_list.sort(bi6_misc.bi6ListPropertySort("name"));
      this.assignedRulesList = assigned_rules_list;
      this.assignedRulesListExistIndexes = assigned_rules_exists_flags;
      ////</end> make the list of rules assigned to this object attribute

      //// make the list of rules that can be assigned to this object attribute
      var unassigned_rules = [];
      for (var key in this.notificationRules) {
        if (key in this.assignedRulesListExistIndexes === false) {
          unassigned_rules.push(this.notificationRules[key]);
        }
      }
      unassigned_rules.sort(bi6_misc.bi6ListPropertySort("name"));
      this.unassignedRulesList = unassigned_rules;
      ////</end> make the list of rules that can be assigned to this object attribute
    },
    updateNotificationGroupsData() {
      // Prevent early calls before orgs data not loads on page reload
      if (window.vue_instance.$data.watchdog.orgCountAndLoading['is_loading'] !== false) {
        return;
      }
      const CI = this;
      let notification_groups_data = [];

      // To get NGPs available from all parent orgs
      const parent_org_uids = window.G_watchdog_data.IV_org_parents_lookup[CI.orgUid];

      // To get NGPs direcly associate with this org
      const orgs_in_path = [...parent_org_uids, CI.orgUid];

      for (let org_uid of orgs_in_path) {
        if (org_uid in CI.DV_orgNotificationGroupJoins == true) {
          for (let key in CI.DV_orgNotificationGroupJoins[org_uid]) {
            let entry = {
              name: CI.getNotificationGroupName(key),
              uid: key
            }
            notification_groups_data.push(entry);
          }
        }
      }

      this.DV_notificationGroupsData = _.orderBy(notification_groups_data, ['name']);
    },
    getNotificationGroupName(ngp_uid) {
      if (ngp_uid in this.DV_notificationGroupMetaData == true && 
          'name' in this.DV_notificationGroupMetaData[ngp_uid] == true) {
        return this.DV_notificationGroupMetaData[ngp_uid]['name'];
      } else {
        return `Loading.. ${ngp_uid}`;
      }
    },
    selectGroupType(ngp_uid) {
      this.DV_selectedGroup = ngp_uid;
      if (this.DV_selectedGroup === "personal") {return;}

      this.DV_loadingNGPRuleJoins = true;

      window.G_watchdog_data.IV_loading_ngp_rules[this.DV_selectedGroup] = true;
      window.G_watchdog_data.bi7InitNotificationGroupRuleJoins(this.DV_selectedGroup);
      window.G_watchdog_data.bi7InitNGPRuleAssignmentListener(this.DV_selectedGroup);
      this.DV_ngpRulesAssignmentDataRef = window.G_watchdog_data.IV_ngp_rule_assignment_data;
      this.DV_notificationGroupsInformation = window.G_watchdog_data.IV_notification_group_rules_information;
      if (this.DV_ngpUidsWithActiveListeners.includes(this.DV_selectedGroup) === false) {
        this.DV_ngpUidsWithActiveListeners.push(this.DV_selectedGroup);
      }
      this.waitForNGPRuleJoinsListener()
    },
    waitForNGPRuleJoinsListener() {
      if (this.DV_selectedGroup === "personal") {return;}

      let loading = window.G_watchdog_data.IV_loading_ngp_rules[this.DV_selectedGroup];
      if (loading === true) {
        setTimeout(
          function() {
            this.waitForNGPRuleJoinsListener()
          }.bind(this), 
          1000
        );
        return;
      }

      this.DV_notificatuinGroupRuleJoinsRef = window.G_watchdog_data.IV_ngp_rule_joins;
      this.updateNGPRuleJoins();
    },
    updateNGPRuleJoins() {
      if (this.DV_selectedGroup === "personal") {return;}
      this.DV_loadingNGPRuleJoins = true;
      let ngp_rules_joins = {}

      if (this.DV_selectedGroup in this.DV_notificatuinGroupRuleJoinsRef === false) {
        this.DV_loadingNGPRuleJoins = false;
        return;
      }

      for (let rule_uid in this.DV_notificatuinGroupRuleJoinsRef[this.DV_selectedGroup]) {
        ngp_rules_joins[rule_uid] = this.DV_notificatuinGroupRuleJoinsRef[this.DV_selectedGroup][rule_uid];
      }

      this.DV_notificationGroupRuleJoins[this.DV_selectedGroup] = ngp_rules_joins;
      this.DV_loadingNGPRuleJoins = false;
    },
    eventChangeRuleNotificationType: function(args) {
      var rule_uid = args[0];
      var notification_types = args[1];
      console.log(args);
    },
  },
  watch: {
    ruleJoins: {
      handler() {
        this.updateRulesList();
      },
      deep: true
    },
    notificationRules: {
      handler() {
        this.updateRulesList();
      },
      deep: true
    },
    DV_notificatuinGroupRuleJoinsRef: {
      handler() {
        if (this.DV_selectedGroup === "personal") {return;}
        if (!this.DV_notificatuinGroupRuleJoinsRef[this.DV_selectedGroup]) {return;}
        this.updateNGPRuleJoins();
      },
      deep: true
    },
    DV_orgNotificationGroupJoins: {
      handler() {
        this.updateNotificationGroupsData();
      },
      deep: true,
    },
    DV_notificationGroupMetaData: {
      handler() {
        this.updateNotificationGroupsData();
      },
      deep: true,
    },
    DV_notificationGroupsInformation: {
      handler() {
        if (!this.DV_notificationGroupsInformation) {return;}
        var info = {}

        for (let rule_uid in this.DV_notificationGroupsInformation) {
          let data = this.DV_notificationGroupsInformation[rule_uid];
          info[rule_uid] = data;
        }

        this.DV_ngpRulesInformationData = info;
      },
      deep: true
    }
  },
  beforeDestroy() {
    const CI = this;
    
    /// Unsubscribe all ngp related listeners started for this component
    // To close listeners for all parent orgs
    const parent_org_uids = window.G_watchdog_data.IV_org_parents_lookup[CI.orgUid];

    // To close listeners this org
    const orgs_in_path = [...parent_org_uids, this.orgUid];

    for (let org_uid of orgs_in_path) {
      window.G_watchdog_data.bi7UnsubscribeSpecificListener('org_ngp_joins', org_uid);
    }

    for (let index in this.DV_ngpUidsWithActiveListeners) {
      let rule_uid = this.DV_ngpUidsWithActiveListeners[index];

      window.G_watchdog_data.bi7UnsubscribeSpecificListener('ngp_rule_joins', rule_uid);
      window.G_watchdog_data.bi7UnsubscribeSpecificListener('ngp_rule_assignments', rule_uid);
    }
    ///</end> Unsubscribe all ngp related listeners started for this component
  }
};
</script>



// WEBPACK FOOTER //
// src/components/p2Dashboard/p2s1MyOrganizations/c2m7ManageNotifications.vue